var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAssetSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.60001,
    y: 11.8984,
    width: 8.2,
    height: 8.2,
    rx: 1,
    fill: "#EEEEEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4,
    cy: 15.9984,
    r: 4.6,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.134 1.5C10.5189 0.833333 11.4811 0.833333 11.866 1.5L15.7631 8.25C16.148 8.91667 15.6669 9.75 14.8971 9.75H7.10289C6.33309 9.75 5.85196 8.91667 6.23686 8.25L10.134 1.5Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssetSolid);
export default __webpack_public_path__ + "static/media/ic_asset_solid.b91f483b20d789046613357e9945bc80.svg";
export { ForwardRef as ReactComponent };